import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from "react-router-dom";
import App from './App'; // Ensure App.js exists and exports the App component
import { createAppTheme } from './theme';
import { ColorModeContext, COLOR_MODE_STORAGE_KEY } from './ColorModeContext';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

function AppRoot() {
  const [mode, setMode] = React.useState(() => {
    try {
      const stored = window.localStorage.getItem(COLOR_MODE_STORAGE_KEY);
      return stored === 'dark' ? 'dark' : 'light';
    } catch (e) {
      return 'light';
    }
  });

  React.useEffect(() => {
    try {
      window.localStorage.setItem(COLOR_MODE_STORAGE_KEY, mode);
    } catch (e) {
      // ignore
    }
  }, [mode]);

  const colorMode = React.useMemo(
    () => ({
      mode,
      setMode,
      toggleColorMode: () => setMode((prev) => (prev === 'light' ? 'dark' : 'light')),
    }),
    [mode]
  );

  const theme = React.useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

root.render(
  <AppRoot />
);